import { CiSearch } from 'react-icons/ci'
import { NavigateFunction } from 'react-router-dom'

import {
  SurveyReportPatientScore,
  SurveyReportScoringRanges
} from '../../api/services/user_assignment_codes/types.ts'
import { Column } from '../../components/common/Table/Table.tsx'

type TableColumn = Column<SurveyReportPatientScore>

export type ScoringMatch = Pick<
  SurveyReportScoringRanges,
  'title' | 'description'
>

export const setSurveyReportTableColumns = (
  scoringRanges: SurveyReportScoringRanges[]
) => {
  const getScoringRangeMeta = (
    scoringRanges: SurveyReportScoringRanges[],
    points: number
  ): ScoringMatch | null => {
    const match = scoringRanges.find(
      (r) => points >= r.min_score && points <= r.max_score
    )

    return match ? { title: match.title, description: match.description } : null
  }

  const columns: TableColumn[] = [
    {
      header: 'Imię i nazwisko',
      accessor: 'patient_name',
      render: (row: SurveyReportPatientScore) => <>{`${row.patient_name}`}</>,
      className: 'w-[250px]',
      sorted: true
    },
    {
      header: 'Wynik',
      accessor: 'points_score',
      render: (row: SurveyReportPatientScore) => <>{`${row.points_score}`}</>,
      className: 'w-[160px]'
    },
    {
      header: 'Tytuł',
      accessor: 'title',
      render: (row: SurveyReportPatientScore) => {
        const title = getScoringRangeMeta(
          scoringRanges,
          row.points_score
        )?.title
        return (
          <span className={'flex overflow-hidden truncate'}>{title}</span>
        )
      },
      className: 'w-[250px] 2xl:w-auto'
    },
    // {
    //   header: 'Opis',
    //   accessor: 'description',
    //   render: (row: SurveyReportPatientScore) => {
    //     const description = getScoringRangeMeta(
    //       scoringRanges,
    //       row.points_score
    //     )?.description
    //     return (
    //       <span className={'flex overflow-hidden truncate'}>{description}</span>
    //     )
    //   },
    //   className: 'w-[250px] 2xl:w-auto px-0'
    // },
    // {
    //   header: '',
    //   accessor: 'more',
    //   render: () => {
    //     return <span className={'cursor-pointer'}>{'(...)'}</span>
    //   },
    //   className: 'w-[20px]',
    //   onHover: (row) => {
    //     const meta = getScoringRangeMeta(scoringRanges, row.points_score)
    //     const description = meta?.description ?? ''
    //     return [{}, {}, {}, { label: description, value: '' }]
    //   }
    // }
  ]

  return columns
}

export const setSurveyReportTableActions = (navigate: NavigateFunction) => {
  return [
    {
      label: 'Przejdź do ankiety pacjenta',
      icon: <CiSearch className="text-lg" />,
      onClick: (row: SurveyReportPatientScore) => {
        navigate(
          `/patient-profile/${row.patient_id}/survey/${row.survey_id}/`,
          {
            state: {
              patientFullName: row.patient_name
            }
          }
        )
      },
      className: 'md:w-auto w-[250px] text-blue-500'
    }
  ]
}
